import ContatoService from "@/services/ContatoService";
import { router } from "../../../main.js";
import lodash from "lodash";

export const actions = {
  cadastrarContato: ({ commit, dispatch }) => {
    commit("setContato", {
      nome: "",
      nome_fantasia: "",
      cpf_cnpj: "",
      tipo_pessoa: "",
      rg_ie: "",
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      uf: "",
      whatsapp: "",
      telefone: "",
      celular1: "",
      celular2: "",
      email_notas: "",
      email: "",
      proxima_visita: "",
      data_nascimento: "",
      sexo: "",
      observacoes: "",
    }),
      dispatch("setModalCadastroContato", true);
  },
  listarContatos: ({ commit }, data) => {
    commit("setOverlay", true);
    ContatoService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setContatos", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  listarTransportadoras: ({ commit }, data) => {
    // commit('setOverley', true)
    ContatoService.listarTransportadoras(data)
      .then((res) => {
        commit("setTransportadoras", res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  listarFornecedores: ({ commit }, data) => {
    ContatoService.listarFornecedores(data)
      .then((res) => {
        commit("setFornecedores", res.data);
      })
      .catch((e) => {
        // commit('setOverley', false)
        console.log(e);
      });
  },

  visualizarContato: ({ commit }, id) => {
    commit("setOverlay", true);
    ContatoService.editar(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setContato", res.data);
        commit("setModalCadastroContato", true);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  buscarContato: ({ commit }, id) => {
    if (id || id != undefined || id != null) {
      commit("setOverlay", true);
      ContatoService.editar(id)
        .then((res) => {
          commit("setOverlay", false);
          if (!res.data.id) {
            commit("snackbarError", "Contato não encontrado");
            commit("setContato", {});
            return;
          }
          commit("setContato", res.data);
        })
        .catch((e) => {
          commit("setOverlay", false);
          console.log(e);
        });
    }
  },
  salvarContato: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    ContatoService.salvar(data)
      .then((res) => {
        commit("setContato", res.data);
        commit("addContato", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Contato cadastrado.");

        if ((data.tipo = "FORNECEDOR")) {
          dispatch("listarFornecedores", {});
        }
        if ((data.tipo = "TRANSPORTADORA")) {
          dispatch("listarTransportadoras", {});
        }
        if ((data.tipo = "CLIENTE")) {
          dispatch("listarContatos", {});
        }
      })
      .catch((e) => {
        // if(e.response.status == 422){
        //     commit('alertError', e.response.data.errors)
        // }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrado.");
      });
  },
  atualizarContato: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    ContatoService.atualizar(data)
      .then((res) => {
        dispatch("listarContatos", { limite: 20, pagina: 1 });
        commit("setContato", res.data);
        commit("setOverlay", false);
        commit("snackbarInfo", "Contato atualizado.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirContato: ({ commit, dispatch }, id) => {
    dispatch("setModalExcluirContato", false);
    dispatch("setModalCadastroContato", false);
    commit("setOverlay", true);
    ContatoService.excluir(id)
      .then((res) => {
        dispatch("listarContatos", { limite: 20, pagina: 1 });
        commit("setOverlay", false);
        commit("snackbarError", "Contato excluído.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("snackbarError", "Erro ao excluir contato.");
      });
  },
  pesquisarContato: ({ commit }, data) => {
    commit("setOverlay", true);
    ContatoService.pesquisarContato(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setContatos", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  setModalCadastroContato: ({ commit }, status) => {
    commit("setModalCadastroContato", false);
    setTimeout(() => {
      commit("setModalCadastroContato", status);
    }, 100);
  },
  setModalExcluirContato: ({ commit }, status) => {
    commit("setModalExcluirContato", false);
    setTimeout(() => {
      commit("setModalExcluirContato", status);
    }, 100);
  },
  setModalPesquisarContato: ({ commit }, status) => {
    commit("setModalPesquisarContato", false);
    setTimeout(() => {
      commit("setModalPesquisarContato", status);
    }, 100);
  },
  visualizarPaginaContato: ({ commit }, data) => {
    commit("setOverlay", true);
    ContatoService.visualizarPagina(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setContatos", res.data);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
};

export default {};
